import React, { useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import Loader from "../../components/Loader/loader";

const EmployeeList = ({
  userDetailResponse,
  setOpenProfile,
  openProfile,
  GetId,
  loading,
}) => {
  const itemsPerPage = 50;
  const [currentPage, setCurrentPage] = useState(1);
  const baseImageURL = process.env.REACT_APP_IMAGE_URL; 

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  }; 

  function HandleChange(param) {
    GetId(param);
  }

 

  function getStatusColor(status) {
    switch (status) {
      case 'ACTIVE':
        return '#28A745';
      case 'INACTIVE':
        return '#DC3545';
      default:
        return 'blue';
    }
  }

  // console.log("userDetailResponseqqqqqq",userDetailResponse)
  return (
    <div className="container-fluid">
      <div className="cityList">
        <table>
          <thead>
            <tr className="cityListHeading">
              <th>S No.</th>
          
              <th>Name</th>
              <th>Department</th>
              <th>Designation</th>
              <th>Tenure</th>
              <th>Email</th>
              <th>Emp Code</th>
              <th>Mobile</th>
              <th>Status</th>
              <th>Details</th>
       
            </tr>
          </thead>
          {loading ? (
            <div style={{ position: "relative", left: "540px" }}>
              <Loader />
            </div>
          ) : (
            <tbody>
              {userDetailResponse?.length > 0 ? (
                userDetailResponse.map((user, index) => (
                  <tr key={user.customer_id}>
                    <td>{startIndex + index + 1}</td>
                    <td>{user.name}</td>
                    <td>{user.department}</td>
                    <td>{user.designation}</td>
                    <td>{user.Tenure}</td>
                    <td>{user.email}</td>
                    <td>{user.emp_code}</td>
                    <td>{user.phoneNo}</td>
                
                    <td>
                      <p
                        style={{
                          height: "30px",
                          width: "100px",
                          color: "white",
                          fontWeight: "bold",
                          textAlign: "center",
                          padding: "4px",
                          borderRadius: "12px",
                          backgroundColor: getStatusColor(user.status),
                        }}
                      >
                        {user.status}
                      </p>
                    </td>
                    <td>
                      <button
                        style={{ height: "30px", width: "38px" }}
                        onClick={() => {
                          setOpenProfile(!openProfile);
                          HandleChange(user.customer_id);
                        }}
                      >
                        <SearchIcon className="icon" />
                      </button>
                    </td>
                  
                  </tr>
                ))
              ) : (
                <p>No employees found</p>
              )}
            </tbody>
          )}
        </table>
      
      </div>
    </div>
  );
};

export default EmployeeList;


